import type { IconAsset } from '../Icon.types';

export const arrowLeft: IconAsset = {
  bold: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M9.5919 10.5L14.5459 5.54596L12.4246 3.42464L3.84925 12L12.4246 20.5754L14.5459 18.4541L9.59189 13.5H19V10.5H9.5919Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M8.62132 8.5L12.5754 4.54596L10.454 2.42464L2.87868 10L10.454 17.5754L12.5754 15.4541L8.62131 11.5H17.0294V8.5H8.62132Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M7.62131 6.5L10.5754 3.54594L8.45405 1.42462L1.87868 7.99999L8.45405 14.5754L10.5754 12.454L7.62133 9.5H14.0294V6.5H7.62131Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
  regular: {
    l: {
      code: (
        <path
          clipRule='evenodd'
          d='M8.38479 11L14.1924 5.1924L12.7782 3.77818L4.55636 12L12.7782 20.2218L14.1924 18.8076L8.38479 13H19V11H8.38479Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    m: {
      code: (
        <path
          clipRule='evenodd'
          d='M7.38478 9L12.1924 4.1924L10.7782 2.77818L3.55861 9.99774L10.7782 17.2173L12.1924 15.8031L7.3893 11H16V9H7.38478Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
    s: {
      code: (
        <path
          clipRule='evenodd'
          d='M6.41423 7L9.70711 3.70712L8.29289 2.29291L2.6783 7.9075L8.29289 13.5221L9.70711 12.1079L6.59922 9H13V7H6.41423Z'
          fill='currentColor'
          fillRule='evenodd'
        />
      ),
    },
  },
};
